import { CommercialAccreditationsTable } from "@/components/commercial/commercial-accreditations-table";
import { CommercialPageShell } from "@/components/commercial/commercial-page-shell";

const PATH = "/commercial-compliance";
const PAGE_TITLE = "Compliance & Accreditations";

export function LpCommercialCompliance() {
  return (
    <CommercialPageShell
      pageTitle={PAGE_TITLE}
      pagePath={PATH}
      sourcePage={PATH}
      serviceOfInterest="Compliance & Accreditations Enquiry"
    submitLabel="Request Accreditation Pack"
      intro={
        <>
          <p className="text-xs font-bold uppercase tracking-widest text-accent mb-2">Compliance</p>
          <h1 className="text-2xl md:text-4xl font-bold text-foreground leading-tight mb-4">
            {PAGE_TITLE}
          </h1>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            Framework buyers need diligence-ready documentation before mobilisation. We publish held
            accreditations and insurances with status and renewal dates where available, so your procurement
            team isn&apos;t chasing certificates mid-tender. Items not yet held are marked &ldquo;On
            request&rdquo; and supplied on request when applicable.
          </p>
        </>
      }
    >
      <CommercialAccreditationsTable showCta />
    </CommercialPageShell>
  );
}

export { PATH as COMMERCIAL_COMPLIANCE_PATH, PAGE_TITLE as COMMERCIAL_COMPLIANCE_TITLE };
